<template>
    <v-app>
        <v-app-bar app color="primary" dark :shrink-on-scroll="$vuetify.breakpoint.smAndUp">
            <v-toolbar-title>IntimJazz Band</v-toolbar-title>
        </v-app-bar>
        <v-card
            class="mx-auto"
            max-width="100%"
            :style="{ 'margin-top': `${$vuetify.breakpoint.smAndUp ? 64 : 56}px`, 'z-index': $vuetify.breakpoint.smAndUp ? 10 : 1 }">
            <jazz-photos />
            <jazz-concerts />
        </v-card>
        <v-content>
            <v-container>
                <v-row>
                    <v-col cols="12" md="7" sm="6">
                        <jazz-videos />
                    </v-col>
                    <v-col cols="12" md="5" sm="6">
                        <jazz-tracks />
                    </v-col>
                </v-row>
            </v-container>
            <jazz-history />
            <jazz-artists />
        </v-content>
    </v-app>
</template>

<script>
import JazzVideos from '@/components/JazzVideos'
import JazzTracks from '@/components/JazzTracks'
import JazzArtists from '@/components/JazzArtists'
import JazzHistory from '@/components/JazzHistory'
import JazzPhotos from '@/components/JazzPhotos'
import JazzConcerts from '@/components/JazzConcerts'

export default {
    name: 'app',
    components: {
        JazzVideos,
        JazzTracks,
        JazzArtists,
        JazzHistory,
        JazzPhotos,
        JazzConcerts
    }
};
</script>

<style>
.v-application {
    background: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 100px,
        #eee 20px,
        #eee 600px
    ) !important;
    background-attachment: fixed !important;
}
</style>
